import { buildQueryFromKeyValuePairs, UrlParamKeyValuePair } from '../../common';
import { getPricingApiConfig } from '../api/pricing-api';
import { formatMarketRegion } from './uppercase-market-region';

export const getFetchSFCCPricesUrlGetBySkus = (
  productSkus: string[],
  queryParams: UrlParamKeyValuePair[] = []
): string => {
  if (!productSkus || productSkus.length === 0) {
    throw new Error('At least one product SKU must be provided.');
  }

  const { marketLocale } = getPricingApiConfig();
  const sfccLocale = formatMarketRegion(marketLocale);

  const productSkusQueryParameter =
    productSkus.length > 1 ? `(${productSkus.join(',')})` : `${productSkus[0]}/prices`;

  const optionalQueryParams =
    queryParams.length > 0 ? `&${buildQueryFromKeyValuePairs(queryParams)}` : '';

  return `/products/${productSkusQueryParameter}?c_method=getPrices&locale=${sfccLocale}${optionalQueryParams}`;
};
